var React = require('react');

function Success (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#38AB50","d":"M2 8c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6-6-2.7-6-6z","key":0}),React.createElement("path",{"fill":"#FFF","d":"M11.23 6.64c.13-.14.2-.32.2-.52s-.07-.37-.2-.5c-.3-.3-.75-.3-1.03 0L7.06 8.93 5.6 7.37c-.15-.13-.33-.2-.52-.2-.2 0-.38.07-.52.2-.13.14-.2.33-.2.52 0 .2.07.37.2.5l2 2.2c.13.14.3.2.5.2s.38-.06.52-.2l3.65-3.96z","key":1})]));
}

Success.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = Success;

Success.default = Success;
